import React from "react";
import { BarElement, CategoryScale, Chart as ChartJS, LinearScale, Tooltip } from "chart.js";
import { Bar } from "react-chartjs-2";
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);
var BarChart = function (_a) {
    var data = _a.data, options = _a.options;
    return React.createElement(Bar, { options: options, data: data });
};
export default BarChart;
//# sourceMappingURL=BarChart.js.map